<template>
<div class="daily">
    <div class="run-once">
        <div v-if="disable" class="icon-util  once-position" @click="checkRunTime(0)" :class="checkArr.includes(0)?'check-radio-disable':'radio-disable'"></div>
        <div v-if="!disable" class="icon-util  once-position" @click="checkRunTime(0)" :class="checkArr.includes(0)?'check-radio':'radio'"></div>
        <span class="once-des-position" :class="shakeAll" @click="checkRunTime(0)">{{$t('language.popup.onlyOnce')}}</span>
        <date-selector ref="onceDate" :scheduleFlage=true @changeDate="onchangeDate" :disable="onceDisableFlage||!checkArr.includes(0)" style="margin-right:10px;/*no*/"></date-selector>
        <time-selector ref="onceTime" :disable="onceDisableFlage||!checkArr.includes(0)" @changeTime="onchangeOnceTime"></time-selector>
    </div>
    <div class="run-everyday">
        <div class="run-daily-everyday">
            <div v-if="disable" class="icon-util radio once-position" @click="checkRunTime(1)" :class="checkArr.includes(1)?'check-radio-disable':'radio-disable'"></div>
            <div v-if="!disable" class="icon-util radio once-position" @click="checkRunTime(1)" :class="checkArr.includes(1)?'check-radio':'radio'"></div>
            <span class="once-des-position" ref="desPosition" :class="shakeAll" @click="checkRunTime(1)">{{$t('language.popup.everyDay')}}</span>
        </div>
        <div class="right-time-box" :class="shakeBox" v-if="!disable">
            <div >
                <div @click="checkDailyRunTime(0)" style="margin-top:10Px;" class="once-position" :class="[!dailyDisableFlage&&checkArr.includes(1)?'icon-util':'disable-check',dailyTimeArr.includes(0)?'icon-util check-small':'nocheck-small-blue']"></div>
                <time-selector ref="dailyTime0" :disable="dailyDisableFlage||!checkArr.includes(1)" @changeTime="onchangeOnceTime1" style="margin-left:10Px;margin-top:10Px;"></time-selector>
            </div>
            <div >
                <div @click="checkDailyRunTime(1)" style="margin-top:10Px;" class="once-position" :class="[!dailyDisableFlage&&checkArr.includes(1)?'icon-util':'disable-check',dailyTimeArr.includes(1)?'icon-util check-small':'nocheck-small-blue']"></div>
                <time-selector ref="dailyTime1" :disable="dailyDisableFlage||!checkArr.includes(1)" @changeTime="onchangeOnceTime2" style="margin-left:10Px;margin-top:10Px;"></time-selector>
            </div>
            <div>
                <div @click="checkDailyRunTime(2)" style="margin-top:10Px;" class="once-position" :class="[!dailyDisableFlage&&checkArr.includes(1)?'icon-util':'disable-check',dailyTimeArr.includes(2)?'icon-util check-small':'nocheck-small-blue']"></div>
                <time-selector ref="dailyTime2" :disable="dailyDisableFlage||!checkArr.includes(1)" @changeTime="onchangeOnceTime3" style="margin-left:10Px;margin-top:10Px;"></time-selector>
            </div>
        </div>

        <div class="right-time-box" :class="shakeBox" v-if="disable">
            <div >
                <div @click="checkDailyRunTime(0)" style="margin-top:8Px;" class="once-position" :class="[!dailyDisableFlage&&checkArr.includes(1)?'icon-util':'',dailyTimeArr.includes(0)?'icon-util check-disable':'icon-util nocheck-disable']"></div>
                <time-selector ref="dailyTime0" :disable="dailyDisableFlage||!checkArr.includes(1)" @changeTime="onchangeOnceTime1" style="margin-left:10Px;margin-top:10Px;"></time-selector>
            </div>
            <div >
                <div @click="checkDailyRunTime(1)" style="margin-top:8Px;" class="once-position" :class="[!dailyDisableFlage&&checkArr.includes(1)?'icon-util':'',dailyTimeArr.includes(1)?'icon-util check-disable':'icon-util nocheck-disable']"></div>
                <time-selector ref="dailyTime1" :disable="dailyDisableFlage||!checkArr.includes(1)" @changeTime="onchangeOnceTime2" style="margin-left:10Px;margin-top:10Px;"></time-selector>
            </div>
            <div >
                <div @click="checkDailyRunTime(2)" style="margin-top:8Px;" class="once-position" :class="[!dailyDisableFlage&&checkArr.includes(1)?'icon-util':'',dailyTimeArr.includes(2)?'icon-util check-disable':'icon-util nocheck-disable']"></div>
                <time-selector ref="dailyTime2" :disable="dailyDisableFlage||!checkArr.includes(1)" @changeTime="onchangeOnceTime3" style="margin-left:10Px;margin-top:10Px;"></time-selector>
            </div>
        </div>

    </div>
</div>
</template>

<script>
import timeSelector from "@/components/common/selector/time_selector";
import dateSelector from "@/components/common/selector/date_selector";
export default {
    props: ['disable'],
    components: {
        "time-selector": timeSelector,
        "date-selector": dateSelector
    },
    data: function () {
        return {
            checkArr: [0],
            dailyTimeArr: [],
            dailyDisableFlage: true,
            onceDisableFlage: false,
            onceDateValue: null,
            onceTime: null,
            times: [],
            dailyTime0: null,
            dailyTime1: null,
            dailyTime2: null,
            shakeBox: '', //用于未选择数据时候的显示
            shakeAll: ''
        };
    },
    mounted() {
        let titileWidth = this.$refs.desPosition.innerText.length;
    },
    methods: {
        onchangeDate(newName) {
            this.onceDateValue = newName;
            this.$parent.$parent.$parent.date = this.onceDateValue;
        },
        onchangeOnceTime(newName) {
            this.onceTime = newName;
            this.times = [];
            let dateTime = this.onceTime;
            this.times.push(dateTime);
            this.$emit('changeTabDaily', this.times);
        },
        onchangeOnceTime1(newName) {
            this.times = [];
            this.dailyTime0 = newName;
            this.judeTime();
            this.$emit('changeTabDaily', this.times);
        },
        judeTime() {
            if (this.dailyTimeArr.includes(0)) {
                this.times.push(this.dailyTime0);
            }
            if (this.dailyTimeArr.includes(1)) {
                this.times.push(this.dailyTime1);
            }
            if (this.dailyTimeArr.includes(2)) {
                this.times.push(this.dailyTime2);
            }
        },
        onchangeOnceTime2(newName) {
            this.times = [];
            this.dailyTime1 = newName;
            this.judeTime();
            this.$emit('changeTabDaily', this.times);
        },
        onchangeOnceTime3(newName) {
            this.times = [];
            this.dailyTime2 = newName;
            this.judeTime();
            this.$emit('changeTabDaily', this.times);
        },
        checkRunTime(index) {
            let that = this;
            if (!that.checkArr.includes(index)) {
               // window.getSelection().empty();
                that.dailyTimeArr = [];
                that.times = [];
                that.checkArr.splice(0, 1);
                that.checkArr.push(index);
                that.$parent.$parent.$parent.weeks = [];
                that.$parent.$parent.$parent.days = [];
                if (index == 0) {
                    that.dailyDisableFlage = true;
                    that.onceDisableFlage = false;
                    that.$parent.$parent.$parent.schedules.type = 'Once';
                    that.$parent.$parent.$parent.date = that.onceDateValue;
                    let dateTime = that.onceTime;
                    that.times.push(dateTime);
                    that.clearOtherTabData();
                } else {
                    that.dailyDisableFlage = false;
                    that.onceDisableFlage = true;
                    that.$nextTick(function () {
                        that.checkDailyRunTime(0);
                    });
                    that.$parent.$parent.$parent.date = null;
                    that.$parent.$parent.$parent.schedules.type = 'Daily';
                }
            }
            that.$emit('changeTabDaily', that.times);

        },
        clearOtherTabData() {
            this.$parent.$parent.$parent.$refs.weekly.weekArr = [];
            this.$parent.$parent.$parent.$refs.monthly.monthArr = [];
        },
        checkDailyRunTime(index) {
            if (!this.dailyDisableFlage) {
                if (this.dailyTimeArr.includes(index)) {
                    this.dailyTimeArr = this.dailyTimeArr.filter(
                        function (ele) {
                            return ele != index;
                        });
                    let removeData;
                    if (index == 0) {
                        removeData = this.dailyTime0;
                    }
                    if (index == 1) {
                        removeData = this.dailyTime1;
                    }
                    if (index == 2) {
                        removeData = this.dailyTime2;
                    }
                    for (let i = 0; i < this.times.length; i++) {
                        if (removeData == this.times[i]) {
                            this.times.splice(i, 1);
                            break;
                        }
                    }
                } else {
                    this.$parent.$parent.$parent.schedules.type = 'Daily';
                    this.dailyTimeArr.push(index);
                    this.clearOtherTabData();
                    this.times = [];
                    this.judeTime();
                }
            }
            this.$emit('changeTabDaily', this.times);
        }
    },
};
</script>

<style>
.right-time-box {
    width: 130px;
    /*no*/
    float: left;
    position: relative;
    top: -10px;
    /*no*/
}

.daily {
    height: 190px;
    /*no*/
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
}

.run-once {
    width: 100%;
    height: 35px;
    /*no*/
    line-height: 35px;
    /*no*/
    margin-bottom: 40px;
    /*no*/

}

.run-daily-everyday {
    height: 35px;
    /*no*/
    line-height: 35px;
    /*no*/
    margin-bottom: 10px;
    /*no*/
    float: left;
}

.once-position {
    position: relative;
    top: 10px;
    /*no*/
    float: left;
}

.once-des-position {
    margin-left: 5px;
    /*no*/
    margin-right: 10px;
    /*no*/
    float: left;
}

.run-everyday {
    width: 100%;
    height: 120px;
    /*no*/
    line-height: 35px;
    /*no*/

}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_schedule/tab_daily.vue